import { Component, AfterViewInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { TableComponent } from '../table/table.component';

@Component({
  selector: 'app-setting-bank',
  templateUrl: './setting-bank.component.html',
  styleUrls: ['./setting-bank.component.scss']
})
export class SettingBankComponent implements AfterViewInit {

  public company_uuid;
  @ViewChild("table", { static: false }) tb: TableComponent;

  constructor(private http: HttpService) {
    this.company_uuid = this.http.getStaticSelectedCompany();
  }

  ngAfterViewInit(): void {
    const setting = 
      { post: {url: '/admin/setting/bank/get', data: {page_nat: true}},
        disabled_pagenat: false,
        fields: [{label: 'No', type: 'index'}, 
        {label: 'Title', type: 'string', key: 'title', filter: 'string'}, 
        {label: 'Payee', type: 'string', key: 'payee', filter: 'string'}, 
        {label: 'Account', type: 'string', key: 'account', filter: 'string'}, 
        {label: 'Status', type: 'status', key: 'status', filter: 'status'}, 
        {label: 'View', type: 'link', key: 'uuid', 'link': '/lo/' + this.company_uuid + '/setting-bank/form', hide: true},
        {label: 'Delete', type: 'delete', key: 'uuid', table: 'setting_bank', title: 'title', hide: true},
      ]}
    this.tb.init(setting);
  }

}
